import Guid from "./Guid";

export default class BaseType {
  Id: string = Guid.Empty;
  Deleted: boolean = false;
}
